module.exports = __webpack_public_path__ + "img/separtor_chevron.9f501fb8.svg";